module.exports = __webpack_public_path__ + "img/labor_day_card_mob_mattress_v1.e610bb3.png";